<template>
  <div>
    <v-dialog :value="true" scrollable persistent :max-width="maxWidth">
      <v-card>
        <v-card-title class="primary modal-title py-0">
          <span>Visualizar
            <span v-if="ehRecurso"> Recurso</span>
            <span v-else> Contrarrazão</span>
          </span>
          <v-spacer/>
          <v-btn icon @click="fecharModal">
            <v-icon size="20" color="white">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="overflow-x: hidden">
          <v-layout row wrap>
            <v-flex xs4 sm4 d-flex>
              <campo-apresentacao labelPadrao="Licitante" :text="dadosRecurso.fornecedor.razaoSocial"/>
            </v-flex>
            <v-flex xs8 sm8 d-flex>
              <div class="az-text">
                <label class="label">Envio</label>
                <div>{{dadosRecurso.dataEnvio | azDate('DD/MM/YYYY HH:mm')}}</div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs4 sm4 d-flex>
              <campo-apresentacao labelPadrao="Edital" :text="dadosLicitacao.numeroEdital"/>
            </v-flex>
            <v-flex xs8 sm8 d-flex>
              <div class="az-text">
                <label class="label">Objeto</label>
                <div v-if="dadosLicitacao.objeto">
                  <v-tooltip v-if="dadosLicitacao.objeto.length > 148" top nudge-top="15" max-width="600">
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <p class="mb-0 text-truncate-multiline texto">{{ dadosLicitacao.objeto.substring(0, 148)+'...' }}</p>
                      </div>
                    </template>
                    <p class="mb-0 text-truncate-multiline" >{{ dadosLicitacao.objeto }}</p>
                  </v-tooltip>
                  <div v-else>
                    <p class="texto">{{ dadosLicitacao.objeto }}</p>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex class="pb-2">
              <p class="text-campo" style="margin-bottom: 5px">Tipos</p>
              <span>
                <v-chip v-for="lote in dadosRecurso.lotes">{{lote.descricao}}</v-chip>
              </span>
            </v-flex>
          </v-layout>
          <p class="text-campo pb-1" style="margin-top: 4px">
            <span>Conteúdo
              <span v-if="ehRecurso"> Recurso</span>
              <span v-else> Contrarrazão</span>
            </span>
          </p>
          <div class="pb-3">{{dadosRecurso.conteudo}}</div>
          <div>
            <p class="text-campo pb-2" style="margin-bottom: 4px">Anexos</p>
            <a v-for="anexo in dadosRecurso.anexos" :href="criarLinkDownloadTemporario(anexo.uri)" class="link-sem-decoracao">
              <v-chip class="mx-1" small>
                {{anexo.nome}}<v-icon class="ml-1">get_app</v-icon>
              </v-chip>
            </a>
            <span v-if="!dadosRecurso.anexos || dadosRecurso.anexos.length < 1">
              Nenhum anexo inserido para
              <span v-if="ehRecurso">este recurso</span>
              <span v-else>esta contrarrazão</span>
            </span>
          </div>
          <v-divider v-if="possuiRespostas" class="my-2"></v-divider>
          <div v-if="possuiRespostas">
            <div v-if="dadosRecurso.respostas && dadosRecurso.respostas.length">
              <div v-for="resposta in dadosRecurso.respostas" :key="resposta.id" class="pb-4">
                <v-layout row wrap>
                  <v-flex xs4 sm4 d-flex>
                    <campo-apresentacao labelPadrao="Responsável" :text="resposta.usuario && resposta.usuario.nome"/>
                  </v-flex>
                  <v-flex xs4 sm4 d-flex>
                    <campo-apresentacao labelPadrao="Origem" :text="formatarTipoOrigem(resposta.tipoOrigem)"/>
                  </v-flex>
                  <v-flex xs4 sm4 d-flex>
                    <div class="az-text" style="margin-top: 4px">
                      <label class="label">Envio</label>
                      <div>{{resposta.dataCriacao | azDate('DD/MM/YYYY HH:mm')}}</div>
                    </div>
                  </v-flex>
                </v-layout>
                <p class="text-campo pb-1" style="margin-top: 4px">
                  Resposta
                  <span v-if="ehRecurso">Recurso</span>
                  <span v-else>Contrarrazão</span>
                </p>
                <div class="pb-3">{{resposta.conteudo}}</div>
                <div>
                  <p class="text-campo pb-2" style="margin-bottom: 4px">Anexos</p>
                  <a v-for="anexo in resposta.anexos" :key="anexo.id" :href="criarLinkDownloadTemporario(anexo.uri)" class="link-sem-decoracao">
                    <v-chip class="mx-1" small>
                      {{anexo.nome}}<v-icon class="ml-1">get_app</v-icon>
                    </v-chip>
                  </a>
                  <span v-if="!resposta.anexos || resposta.anexos.length < 1">
                    Nenhum anexo inserido para esta resposta
                  </span>
                </div>
                <v-divider v-if="dadosRecurso.respostas.length > 1" class="mt-4"></v-divider>
              </div>
            </div>
            <div v-else>
            <v-flex xs8 sm8 d-flex>
              <div class="az-text" style="margin-top: 4px">
                <label class="label">Envio</label>
                <div>{{dadosRecurso.dataFinalEnvioResposta | azDate('DD/MM/YYYY HH:mm')}}</div>
              </div>
            </v-flex>
            <p class="text-campo pb-1" style="margin-top: 4px">
              Resposta
              <span v-if="ehRecurso">Recurso</span>
              <span v-else>Contrarrazão</span>
            </p>
            <div class="pb-3">{{dadosRecurso.resposta}}</div>
            <div>
              <p class="text-campo pb-2" style="margin-bottom: 4px">Anexos</p>
              <a v-for="anexo in dadosRecurso.respostaAnexos" :href="criarLinkDownloadTemporario(anexo.uri)" class="link-sem-decoracao">
                <v-chip class="mx-1" small>
                  {{anexo.nome}}<v-icon class="ml-1">get_app</v-icon>
                </v-chip>
              </a>
              <span v-if="!dadosRecurso.respostaAnexos || dadosRecurso.respostaAnexos.length < 1">
                Nenhum anexo inserido para esta resposta
              </span>
            </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import CampoApresentacao from '@/commons/components/campos/campo-apresentacao.vue'
import LicitacaoRecursoAnexo
  from "@/views/licitacao/detalhe/orgao/recursocontrarrazao/LicitacaoRecursoContrarrazaoAnexo.vue";
import LicitacaoRecursoContrarrazaoAnexo
  from "@/views/licitacao/detalhe/orgao/recursocontrarrazao/LicitacaoRecursoContrarrazaoAnexo.vue";
import {tipoRecursoContrarrazao} from "@/commons/constants";

export default {
  name: 'ModalVisualizarRecursoContrarrazao',
  components: {
    LicitacaoRecursoContrarrazaoAnexo, LicitacaoRecursoAnexo, CampoApresentacao
  },
  props: {
    tipo:{
      type: String,
      default: tipoRecursoContrarrazao.RECURSO
    },
    dadosLicitacao: {
      type: Object,
      default: null
    },
    dadosRecurso:{
      type: Object,
      default: null
    },
    maxWidth: {
      type: String,
      default: '800'
    },
  },
  data() {
    return {
      tipoRecursoContrarrazao
    }
  },
  computed:{
    ehRecurso(){
      return this.tipo === tipoRecursoContrarrazao.RECURSO
    },
    possuiRespostas() {
      return (this.dadosRecurso.respostas && this.dadosRecurso.respostas.length > 0) || this.dadosRecurso.respondido
    }
  },
  methods: {
    fecharModal() {
      this.$emit('fecharModal')
    },
    formatarTipoOrigem(tipoOrigem) {
      return tipoOrigem === 'AUTORIDADE_SUPERIOR' ? 'Autoridade Superior' : 'Membro da Comissão'
    }
  }
}
</script>

<style lang="stylus">

.max-percent
  max-width 90%

.tabulacao-content
  margin-left 10px

.modal-title
  margin: 0
  padding: 10px 20px
  font-size: 18px !important
  color: white

.actions-modal
  border-top solid thin rgba(0, 0, 0, .12)
  padding-top 10px
  margin-top 0

&-conteudo
  min-height 350px

.container-header-text
  display flex
  flex-direction row
  justify-content center
  align-items center

.text-campo
  margin 0
  font-size 14px
  font-weight bold
  color #3A6861 !important

.textarea-conteudo-recurso
  padding-top 0 !important

  textarea
    padding 5px !important
    color #777 !important

  .v-input__slot
    border 1px solid #CCCCCC
    border-radius 5px

.select-analise
  margin 0 !important
  padding-top 0 !important
  .v-select__selections
    color #777 !important

.label
  font-size 14px
  font-weight bold
  color #3A6861 !important

.texto
  font-size 14px
  color #777 !important

.link-sem-decoracao a, a:link, a:hover, a:visited, a:active
  color: inherit
  text-decoration: none
</style>